export const PROGRAM_SHAPING = 1;
export const PROGRAM_BULKING = 2;
export const PROGRAM_CUTTING = 3;
export const PROGRAM_FITNESS = 4;
export const PROGRAM_STRETCH = 5;
export const PROGRAM_FIGHT = 6;
export const PROGRAM_REHABILITATION = 7;
export const PROGRAM_SPINE_CARE = 8;
export const PROGRAM_POSTURE_CORRECTION = 9;
export const PROGRAM_PILATES = 10;
export const PROGRAM_OTHER = 11;

export default [
    {
        id: PROGRAM_SHAPING,
        name: '塑形',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_BULKING,
        name: '增肌',
        has_options: 1,
        has_manual_options: 0,
        options: [
            {
                id: 1,
                name: '胸',
            },
            {
                id: 2,
                name: '背',
            },
            {
                id: 3,
                name: '腿',
            },
            {
                id: 4,
                name: '肩',
            },
            {
                id: 5,
                name: '肱二头',
            },
            {
                id: 6,
                name: '肱三头',
            },
            {
                id: 7,
                name: '核心肌肉群',
            },
        ],
    },
    {
        id: PROGRAM_CUTTING,
        name: '减脂',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_FITNESS,
        name: '体能训练',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_STRETCH,
        name: '拉伸',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_FIGHT,
        name: '搏击',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_REHABILITATION,
        name: '康复',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_SPINE_CARE,
        name: '脊椎护理',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_POSTURE_CORRECTION,
        name: '体态纠正',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_PILATES,
        name: '普拉提',
        has_options: 0,
        has_manual_options: 0,
        options: [],
    },
    {
        id: PROGRAM_OTHER,
        name: '其它',
        has_options: 0,
        has_manual_options: 1,
        options: [],
    },
];



// WEBPACK FOOTER //
// ./src/constants/programs.js